import React, { useEffect, useState } from "react";

import { useSelector } from "react-redux";

import cx from "classnames";
import dateformat from "dateformat";
import _, { set } from "lodash";
import styles from "./analytics.module.scss";
import { downloads } from "src/localization/english/commons";
import {
  AUDIO_ANALYTICS,
  CLEVERSTORY_VIEWER,
  PAGE_ANALYTICS,
  VIDEO_ANALYTICS,
} from "src/constants/assets";
import PageAnalytics from "src/components/analytics/page";
import VideoAnalytics from "src/components/analytics/video";
import AudioAnalytics from "src/components/analytics/audio";
import { FileService } from "src/utils/file.service";
import { useDispatch } from "react-redux";
import { fetchAssetInsights } from "src/redux/actions/assets";
import { formatTimespent } from "src/services/reports.service";

import DOMPurify from "dompurify";
import { ReadMoreHtml } from "src/components/readMore";
import Collapse from "../animation/collapse";
import { useAssetAdoption } from "src/redux/actions/adoption/asset";
import { Image } from "react-bootstrap";
import userRoleService from "src/utils/userRoles.service";
import AssetService from "src/utils/asset.service";

const cleverStoryImage = '/images/cleverstory.png'

const Analytics: React.FC<{ toggleShowAnalytics: () => void }> = ({
  toggleShowAnalytics,
}) => {
  
  const {trackAssetAnalyticsScreenView} = useAssetAdoption();
  const dispatch = useDispatch();

  const [filterType, setFilterType] = useState("ALL");
  const asset = useSelector((state: any) => _.get(state, "asset.item", null));
  const loading = useSelector((state: any) =>
    _.get(state, "asset.analytics.loading", true),
  );
  const analytics = useSelector((state: any) =>
    _.get(state, "asset.analytics.item", null),
  );
  const firstName = _.get(asset, "createdBy.firstName", null);
  const lastName = _.get(asset, "createdBy.lastName", null);
  const createdDate = AssetService.getNumericValue(asset, "createdDate")
  const modifiedDate = AssetService.getNumericValue(asset, "contentModifiedDate")
  const expiryDate =  AssetService.getNumericValue(asset, "expiryDate")

  const supportedFileTypes = [
    "AUDIO",
    "DOC",
    "DOCX",
    "G-DOC",
    "G-SLIDES",
    "PDF",
    "PPT",
    "PPTX",
    "VIDEO",
    "WORD",
  ];
  const isSeekEnabled = useSelector(
    (state: any) => _.get(state, "accounts.item.seekEnabled") && _.get(asset, "seek"),
  );
  const insightsExists = _.get(analytics, "avgTimeSpent") > 0;
  const fileType = FileService.getFileType(_.get(asset, "metadata"));

  const [smartInsightsEnabled, setSmartInsightsEnabled] = useState(false);

  const [analyticsData, setAnalyticsData] = useState<any>();

  const [showAllCustomFields, setShowAllCustomFields] = useState(false);

  const assetInsights = useSelector((state: any) => _.get(state, "asset.insights.item", null));
  const assetInsightsLoading = useSelector((state: any) => _.get(state, "asset.insights.loading", true));
  const viewer  = useSelector((state: any) => _.get(state, "asset.item.viewer", false));
  
  const calculateDatapoints = (type:string) => {
    let dataPoints = Array();

    if (
      !analytics ||
      analytics.pageCount == 0 ||
      !analytics.dataPoints ||
      analytics.dataPoints.length == 0
    ) {
      return dataPoints;
    }

    analytics.dataPoints.forEach((element: any) => {
      let newElement = {
        totalTimeSpent: 0,
        count: 0,
        avgTimeSpent: 0,
        index: 0,
      };
      if (type === "ALL") {
        newElement.totalTimeSpent = element.totalTimeSpent;
        newElement.count = element.count;
        let avgTimeSpent =
          element.count > 0 ? element.totalTimeSpent / element.count : 0;
        newElement.avgTimeSpent = avgTimeSpent;
      } else if (type === "TEAM") {
        newElement.totalTimeSpent = element.internalTotalTimeSpent;
        newElement.count = element.internalCount;
        let avgTimeSpent =
          newElement.count > 0
            ? element.internalTotalTimeSpent / element.internalCount
            : 0;
        newElement.avgTimeSpent = avgTimeSpent;
      } else if (type === "AUDIENCE") {
        newElement.totalTimeSpent =
          element.totalTimeSpent - element.internalTotalTimeSpent;
        newElement.count = element.count - element.internalCount;
        let avgTimeSpent =
          newElement.count > 0
            ? newElement.totalTimeSpent / newElement.count
            : 0;
        newElement.avgTimeSpent = avgTimeSpent;
      }
      newElement.index = element.index;
      dataPoints.push(newElement);
    });

    return dataPoints;
  };

  const calculateAnalytics = (type: string) => {
    let updatedAnalytics: {
      views: number;
      downloads: number;
      avgTimeSpent: number;
      shares: number;
      type: string;
      pageCount: number;
      dataPoints: {
        totalTimeSpent: number;
        count: number;
        avgTimeSpent: number;
        index: number;
      }[];
    } = {
      views: 0,
      downloads: 0,
      avgTimeSpent: 0,
      shares: 0,
      type: "",
      pageCount: 0,
      dataPoints: [],
    };

    if (!analytics) {
      return null;
    }
  const calculateAvgTimeSpent = () => {
    if (analytics.internalTotalTimeSpent === 0 || analytics.internalViews === 0) {
      return 0;
    } else {
      return analytics.internalTotalTimeSpent / analytics.internalViews;
    }
  };
    if (type === "ALL") {
      updatedAnalytics.views = analytics.views;
      updatedAnalytics.downloads = analytics.downloads;
      updatedAnalytics.avgTimeSpent = analytics.avgTimeSpent;
    } else if (type === "TEAMS") {
      updatedAnalytics.views = analytics.internalViews;
      updatedAnalytics.downloads = analytics.internalDownloads;
      updatedAnalytics.avgTimeSpent = calculateAvgTimeSpent()
    } else if (type === "AUDIENCE") {
      updatedAnalytics.views = analytics.views - analytics.internalViews;
      updatedAnalytics.downloads =
        analytics.downloads - analytics.internalDownloads;
      let externalTimeSpent =
        analytics.totalTimeSpent - analytics.internalTotalTimeSpent;
      let externalViews = analytics.views - analytics.internalViews;
      updatedAnalytics.avgTimeSpent =
        externalViews > 0 ? externalTimeSpent / externalViews : 0;
    }

    updatedAnalytics.shares = analytics.shares;
    updatedAnalytics.type = analytics.type;
    updatedAnalytics.pageCount = analytics.pageCount;
    updatedAnalytics.dataPoints = calculateDatapoints(type);

    return updatedAnalytics;
  };

  const renderCharts = () => {
    if (!analyticsData) {
      return null;
    }

    switch (analyticsData.type) {
      case PAGE_ANALYTICS:
        return <PageAnalytics analytics={analyticsData} />;
        
      case VIDEO_ANALYTICS:
        return <VideoAnalytics height={150} width={250} analytics={analyticsData} metadata={asset.metadata}/>;

      case AUDIO_ANALYTICS:
        return <AudioAnalytics height={150} width={250} analytics={analyticsData} metadata={asset.metadata}/>;

      default:
        return false;
    }
  };

  const handleFilterClick = (type: string) => {
    setFilterType(type);
    let data: any = calculateAnalytics(type);
    setAnalyticsData(data);
  };

  const renderCustomFieldValues = (options) => {
    var values = options.map(item => {
      var isLong = false;
      var value = item.value;
      if (value.trim().length > 40) {
        value = value.substring(0, 29);
        isLong = true;
      }
      return (
        <p key={item.id} className={styles.value}>#{value}{isLong && `...`}</p>
      )
    })

    return values;
  } 

  useEffect(() => {
    trackAssetAnalyticsScreenView();
    
    if (
      isSeekEnabled &&
      insightsExists &&
      supportedFileTypes.includes(fileType)
    ) {
      setSmartInsightsEnabled(true);
      dispatch(fetchAssetInsights({id: asset.id}))
    }

    let data: any = calculateAnalytics(filterType);
    setAnalyticsData(data);
  }, []);

  useEffect(() => {
    let data: any = calculateAnalytics(filterType);
    setAnalyticsData(data);
  }, [analytics]);
  

  if (loading || !analyticsData) {
    return <div>Loading Analytics</div>;
  }

  return (
    <section className={styles.container}>
      <div className={styles.verticalLine}></div>
      <div className={styles.header}>
        <h3>asset analytics</h3>
        <i
          className={cx(styles.closeButton, "paperflite-close")}
          onClick={() => toggleShowAnalytics()}
        />
      </div>
      <div className={styles.chartsContainer}>
        <div className={styles.filters}>
          <span
            onClick={() => handleFilterClick("ALL")}
            className={cx(styles.type, {
              [styles.active]: filterType === "ALL",
            })}
          >
            All Info
          </span>
          <span
            onClick={() => handleFilterClick("TEAMS")}
            className={cx(styles.type, {
              [styles.active]: filterType === "TEAMS",
            })}
          >
            Teams
          </span>
          <span
            onClick={() => handleFilterClick("AUDIENCE")}
            className={cx(styles.type, {
              [styles.active]: filterType === "AUDIENCE",
            })}
          >
            Audience
          </span>

          <div
            className={cx(styles.borderline, {
              [styles.activeAll]: filterType === "ALL",
              [styles.activeTeams]: filterType === "TEAMS",
              [styles.activeAudience]: filterType === "AUDIENCE",
            })}
          />
        </div>

        <div className={styles.charts}>{renderCharts()}</div>

        <div className={styles.content}>
          <div>
            <p className={styles.count}>{analyticsData.views}</p>
            <p className={styles.type}>VIEWS</p>
          </div>

          <div>
            <p className={styles.count}>{analyticsData.downloads}</p>
            <p className={styles.type}>DOWNLOADS</p>
          </div>
          {userRoleService.canShare() &&
          <div>
            <p className={styles.count}>{analyticsData.shares}</p>
            <p className={styles.type}>SHARES</p>
          </div>
          } 
          <div>
            <p className={styles.count}>{formatTimespent(_.get(analyticsData, "avgTimeSpent", 0))}</p>
            <p className={styles.type}>AVG. TIME</p>
          </div>
        </div>
        <div className={styles.line}></div>
      </div>

      {asset.summary && (
        <div className={styles.assetSummary}>
          <ReadMoreHtml style={{maxHeight: "150px"}}>
            <div dangerouslySetInnerHTML={{ __html: asset.summary || "" }} />
          </ReadMoreHtml>
        </div>
      )}

      {_.size(asset.tags) > 0 && (
        <div className={styles.tags}>
          <div className={styles.tagsContainer}>
            {asset.tags.map((tag: string, index: number) => (
              <span key={index} className={styles.tag}>
                #{tag}
              </span>
            ))}
          </div>
        </div>
      )}

      {_.size(asset.customFields) > 0 && (
        <>
          <div className={styles.customFields}>
            {!showAllCustomFields && (
              <div key={1} className={styles.fields}>
                <span className={styles.label}>
                  {asset.customFields[0].name} -{" "}
                </span>
                <span className={styles.value}>
                  {renderCustomFieldValues(asset.customFields[0].value)}
                </span>
              </div>
            )}
            <Collapse isOpen={showAllCustomFields}>
              {showAllCustomFields &&
                asset.customFields.map((field: any, index: number) => (
                  <div key={index} className={styles.fields}>
                    <span className={styles.label}>{field.name} - </span>
                    <span className={styles.value}>
                      {renderCustomFieldValues(field.value)}
                    </span>
                  </div>
                ))}
            </Collapse>
          </div>
          {asset.customFields.length > 1 && (
            <div
              className={styles.showMoreButton}
              onClick={() => setShowAllCustomFields(!showAllCustomFields)}
            >
              <span className={styles.showMoreLess}>{!showAllCustomFields ? "show more" : "show less"}</span>
              <i
                className={`fa ${!showAllCustomFields ? "fa-angle-down" : "fa-angle-up"}`}
              ></i>
            </div>
          )}
          <div className={styles.line}></div>
        </>
      )}
      <div className={styles.summaryMetadata}>
        <p className={styles.summary}>
          <span className={styles.subtext}>
            {firstName} {lastName}
          </span>
          , a publisher, created a document on{" "}
          {dateformat(createdDate, "d mmm, yyyy")}.
          {modifiedDate && (
            <>
              {" "}
              The document was last
              <span className={styles.subtext}>
                {" "}
                updated on {dateformat(modifiedDate, "d mmm, yyyy")}{" "}
              </span>
            </>
          )}
          and is hosted on{" "}
          <span className={styles.subtext}>
            {
              viewer !== CLEVERSTORY_VIEWER && (_.get(asset,"datasource.type") || "Paperflite Cloud Platform")
            }
            {
              viewer === CLEVERSTORY_VIEWER && <Image src={cleverStoryImage} className={styles.cleverstoryLogo} alt="Cleverstory Logo"  /> 
            }
            </span>.
          {expiryDate && (
            <>
              {" "}
              The document will{" "}
              <span className={styles.subtext}>
                expire on {" "}
                {dateformat(expiryDate, "d mmm, yyyy")}
              </span>
              .
            </>
          )}
        </p>
      </div>

      {smartInsightsEnabled && (
        <div className={styles.smartInsights}>
          <h3 className={styles.heading}>Smart Insights</h3>
          {assetInsightsLoading && (
            <span className={styles.content}>Loading...</span>
          )}
          {!assetInsightsLoading && assetInsights && (
            <span className={styles.content}>
              <span
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(assetInsights),
                }}
              ></span>
            </span>
          )}
        </div>
      )}

      <div className={styles.footer}></div>
    </section>
  );
};

export default Analytics;
